import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics, getVisitorId } from '../services/analytics';

/**
 * 访客心跳：进入/切换页面即上报一次，并每 90s 续一次（仅页面可见时）。
 * 用于仪表盘「今日访客」「当前在线」。后台 /admin 路径不计入访客。fire-and-forget。
 */
export function useVisitorPing() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    const id = getVisitorId();
    analytics.ping(id);
    const timer = setInterval(() => {
      if (document.visibilityState === 'visible') analytics.ping(id);
    }, 90_000);
    return () => clearInterval(timer);
  }, [pathname]);
}
